import React from 'react';
import './index.css'
import DropdownMenu from '../common/DropdownMenu';
import InputLabel from '../common/InputLabel';
import { TicketUpdateFormModel } from '../../models/ticket.model';

interface CustomFieldsProps {
  action?: string
  handleChange?: (...args: any[]) => void
  ticketUpdateForm: TicketUpdateFormModel
}

const CustomFields: React.FC<CustomFieldsProps> = ({action, handleChange, ticketUpdateForm }) => {

  return (
    <React.Fragment>
      <div className='tkt-form-section'>
        <DropdownMenu label='Campos Personalizados'>
          {(
            Object.entries(ticketUpdateForm.custom_fields).map(([key, field], index) => (
              <div className='tkt-form-section-item' key={index}>
                <InputLabel
                  label={field.hname}
                  type={field.type}
                  name={key}
                  value={field.value}
                  onChange={handleChange}
                  disabled={action !== 'create'}
                />
              </div>
            ))
          )}
        </DropdownMenu>
      </div>

    </React.Fragment>
  );
}

export default CustomFields;
